import { render, staticRenderFns } from "./valida_vivienda.vue?vue&type=template&id=3c38ae6e&scoped=true"
import script from "./valida_vivienda.vue?vue&type=script&lang=js"
export * from "./valida_vivienda.vue?vue&type=script&lang=js"
import style0 from "./valida_vivienda.vue?vue&type=style&index=0&id=3c38ae6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c38ae6e",
  null
  
)

export default component.exports